module.exports = __webpack_public_path__ + "img/08.6d948541.jpg";